<template>
    <div>
        <NavbarOne/>

        <div class="flex">
            <div class="w-1/2 hidden md:block lg:flex-1">
                <img class="h-full object-cover" :src="bg" alt="forgot password">
            </div>
            <div class="w-full md:w-1/2 lg:max-w-lg xl:max-w-3xl lg:w-full py-16 px-[20px] sm:px-8 lg:p-16 xl:p-24 relative z-10 flex items-center overflow-hidden">
                <div class="mx-auto md:mx-0 max-w-md w-full">
                    <h2 class="leading-none" data-aos="fade-up">Forgot your password?</h2>
                    <p class="text-lg mt-[15px]" data-aos="fade-up" data-aos-delay="100">
                        Enter the email address on your account and we will send you a link to choose a new password.
                    </p>

                    <form class="mt-7" @submit.prevent="submit">
                        <div data-aos="fade-up" data-aos-delay="200">
                            <label for="reset-email" class="text-base sm:text-lg font-medium leading-none mb-2.5 block dark:text-white">Email</label>
                            <input
                                id="reset-email"
                                v-model="email"
                                class="w-full h-12 md:h-14 bg-white dark:bg-transparent border border-bdr-clr focus:border-primary p-4 outline-none duration-300"
                                type="email"
                                placeholder="Enter your email address"
                                autocomplete="email"
                                required
                            >
                            <p v-if="fieldError" class="mt-2 text-sm text-[#E13939]">{{ fieldError }}</p>
                        </div>
                        <div data-aos="fade-up" data-aos-delay="300">
                            <button type="submit" class="btn btn-theme-solid mt-[15px]" :data-text="submitting ? 'Sending...' : 'Send reset link'" :disabled="submitting">
                                <span>{{ submitting ? 'Sending...' : 'Send reset link' }}</span>
                            </button>
                        </div>
                    </form>

                    <p v-if="successMessage" class="text-base mt-5 text-[#31A051]">{{ successMessage }}</p>
                    <p v-if="generalError" class="text-base mt-5 text-[#E13939]">{{ generalError }}</p>

                    <p class="text-lg mt-[15px]" data-aos="fade-up" data-aos-delay="400">
                        Remembered it? <router-link to="/login" class="text-primary">Back to login</router-link>
                    </p>
                </div>
            </div>
        </div>
        <FooterOne/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';

    import NavbarOne from '@/components/navbar/navbar-one.vue';
    import FooterOne from '@/components/footer/footer-one.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';

    import bg from '@/assets/img/bg/forget-pass.jpg'
    import Aos from 'aos';
    import { apiRequest } from '@/lib/client-api';

    onMounted(() => {
        Aos.init();
    });

    const email = ref('');
    const submitting = ref(false);
    const successMessage = ref('');
    const generalError = ref('');
    const fieldError = ref('');

    async function submit() {
        submitting.value = true;
        successMessage.value = '';
        generalError.value = '';
        fieldError.value = '';

        try {
            const response = await apiRequest('/auth/forgot-password', {
                method: 'POST',
                data: { email: email.value },
            });

            successMessage.value = response.message;
            email.value = '';
        } catch (error) {
            fieldError.value = error.errors?.email?.[0] || '';
            generalError.value = fieldError.value
                ? ''
                : (error.message || 'We could not send the reset link. Please try again.');
        } finally {
            submitting.value = false;
        }
    }
</script>
